exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".placeholder-image-container[data-v-19a11e43] {\n  margin: auto auto;\n  max-width: 100%;\n  max-height: 10rem !important;\n  width: auto !important;\n  height: auto !important;\n  background: #000;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n.mb-0 img[data-v-19a11e43] {\n  vertical-align: baseline;\n  margin-right: 0.125rem;\n}", ""]);

// exports
